import React from 'react';
import { useState } from 'react';
import { ViewType } from "./ChangeEmailAddressTypes";
import SetUpNewEmail from "./SetUpNewEmail/SetUpNewEmail";
import EnterOneTimePassword from "./EnterOneTimePassword/EnterOneTimePassword";
import { CustomModal, Typography } from 'seagull';
import ManyAttemptsError from "./ManyAttemptsError/ManyAttemptsError";
import styles from "./ChangeEmailAddress.module.scss";
import VerifyNewEmail from "./VerifyNewEmail/VerifyNewEmail";
function ChangeEmailAddressModal(_ref) {
  let {
    onClose
  } = _ref;
  const [view, setView] = useState(ViewType.EnterOneTimePassword);
  const [newUserEmail, setNewUserEmail] = useState('');
  const handleSetView = view => {
    setView(view);
  };
  const getViewContent = () => {
    switch (view) {
      case ViewType.EnterOneTimePassword:
        return /*#__PURE__*/React.createElement(EnterOneTimePassword, {
          handleSetView: handleSetView,
          onClose: onClose
        });
      case ViewType.SetUpNewEmail:
        return /*#__PURE__*/React.createElement(SetUpNewEmail, {
          handleSetView: handleSetView,
          onClose: onClose,
          handleSetNewEmail: setNewUserEmail
        });
      case ViewType.VerifyNewEmail:
        return /*#__PURE__*/React.createElement(VerifyNewEmail, {
          handleSetView: handleSetView,
          handleClose: onClose,
          newUserEmail: newUserEmail
        });
      case ViewType.TooManyAttempts:
        return /*#__PURE__*/React.createElement(ManyAttemptsError, {
          onClose: onClose
        });
    }
  };
  return /*#__PURE__*/React.createElement(CustomModal, {
    width: "660px",
    "data-testid": "change-email-address-modal",
    title: "Change Email Address",
    onClose: onClose,
    headerClassName: styles.header,
    header: /*#__PURE__*/React.createElement(Typography, {
      className: styles.header,
      variant: "h6",
      weight: "bold"
    }, "Change email address")
  }, getViewContent());
}
export default ChangeEmailAddressModal;